
import React from 'react'
import EditDiskjockey from '../components/EditDiskjockey'

export default props => <EditDiskjockey {...props} />
